import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getReferralBonusHistory } from "../../services/referralBonusHistoryService";
import { toast } from "react-toastify";

const initialState = {
  records: [],
  total: 0,
  grandTotal: null, // only populated when includeTotal=true
  page: 1,
  status: "idle",
  error: null,
};

export const fetchReferralBonusHistory = createAsyncThunk(
  "referralBonusHistory/fetchAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await getReferralBonusHistory(params);
      return response;
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        "Failed to fetch referral bonus history";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  },
);

const referralBonusHistorySlice = createSlice({
  name: "referralBonusHistory",
  initialState,
  reducers: {
    resetReferralBonusHistory: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralBonusHistory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchReferralBonusHistory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.records = action.payload.data?.referralHistory || [];
        state.total = action.payload.data?.total || 0;
        state.grandTotal = action.payload.data?.totalReferralBonus ?? null;
        state.page = action.payload.data?.page || 1;
        state.error = null;
      })
      .addCase(fetchReferralBonusHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.records = [];
        state.total = 0;
        state.grandTotal = null;
        state.page = 1;
      });
  },
});

export const { resetReferralBonusHistory } = referralBonusHistorySlice.actions;
export default referralBonusHistorySlice.reducer;
